function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  role: "img"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#b5c0c6}.cls-5{fill:#bdc8d0}.cls-6{fill:#ffc160}.cls-7{fill:#fff}.cls-8{fill:#ffe5bd}.cls-9{fill:#ffae30}.cls-10{fill:#ffd088}.cls-11{fill:#fef7e7}")), /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Cone"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 100,
  r: 100,
  fill: "#e5f7e3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53 140h100v8H53z",
  className: "cls-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53 58h2v6h-2zm97 0h2v6h-2z",
  style: {
    fill: "#d2d5d8"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 142,
  r: 2,
  fill: "#dce2e7"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 96,
  x: 50,
  y: 63,
  className: "cls-5",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 96,
  x: 147,
  y: 63,
  className: "cls-5",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 26,
  x: 40,
  y: 68,
  className: "cls-6",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M147 72h8v26h-8zm-97 0h8v26h-8zm97 38h8v26h-8zm-97 0h8v26h-8z",
  className: "cls-2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 26,
  x: 40,
  y: 68,
  className: "cls-7",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 26,
  x: 40,
  y: 105,
  className: "cls-7",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "m63.48 68-6.96 26h12l6.96-26zM44 68a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h1.52l7-26zm42.48 0-6.96 26h12l6.96-26zM160 90V72a4 4 0 0 0-4-4h-.52l-7 26H156a4 4 0 0 0 4-4m-50.52-22-6.96 26h12l6.96-26zm23 0-6.96 26h12l6.96-26zm-69 37-6.96 26h12l6.96-26zM44 105a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h1.52l7-26zm42.48 0-6.96 26h12l6.96-26zM160 127v-18a4 4 0 0 0-4-4h-.52l-7 26H156a4 4 0 0 0 4-4m-50.52-22-6.96 26h12l6.96-26zm23 0-6.96 26h12l6.96-26z",
  className: "cls-6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 54,
  r: 6,
  className: "cls-6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 54,
  r: 6,
  className: "cls-6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 54,
  r: 3,
  className: "cls-8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 54,
  r: 3,
  className: "cls-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.79 159h-19.12l7.55-27.33a.91.91 0 0 1 .88-.67h2.26a.91.91 0 0 1 .88.67z",
  className: "cls-9"
}), /*#__PURE__*/React.createElement("rect", {
  width: 27.32,
  height: 2.73,
  x: 150.68,
  y: 156.27,
  className: "cls-10",
  rx: 1.37
}), /*#__PURE__*/React.createElement("path", {
  d: "m171.71 151.49-1.51-5.47h-11.95l-1.5 5.47zm-3.21-11.61-1.32-4.78h-5.9l-1.33 4.78z",
  className: "cls-11"
}), /*#__PURE__*/React.createElement("path", {
  d: "m34.6 154.61 8.14-17.7 22.09 18.63a.94.94 0 0 1 .25 1.1l-1 2.09a1 1 0 0 1-1 .53z",
  className: "cls-9"
}), /*#__PURE__*/React.createElement("rect", {
  width: 27.84,
  height: 2.78,
  x: 25.97,
  y: 145.06,
  className: "cls-10",
  rx: 1.39,
  transform: "rotate(114.7 39.895 146.442)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m57.65 149.48-3.81 8.27 5.71.92 2.51-5.47zm-15.21 6.41 5.7.93 5.09-11.07-4.42-3.72z",
  className: "cls-11"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#98efbb",
  d: "M180.74 159H19.26a100 100 0 0 0 161.48 0"
}))));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/img-construction.svg";
export { SvgComponent as ReactComponent };